import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actiontypes";
import * as models from "./model";
import TaskCodeApi from "./taskCodeApi";

import { push } from "redux-little-router";

export type TaskCodeAction =
      ({ type: typeof actions.LOAD_TASKCODES_SUCCESS } & Payload<models.TaskCodeListModel[]>)
    | ({ type: typeof actions.CREATE_TASKCODE_SUCCESS } & Payload<models.TaskCodeDetailModel>)
    | ({ type: typeof actions.LOAD_TASKCODE_DETAIL_SUCCESS } & Payload<models.TaskCodeDetailModel>)
    | ({ type: typeof actions.SAVE_TASKCODE_SUCCESS } & Payload<models.TaskCodeDetailModel>)
    | ({ type: typeof actions.DELETE_TASKCODE_SUCCESS } & Payload<any>);

export const loadTaskCodesSuccess = (payload: models.TaskCodeListModel[]): TaskCodeAction => ({
    payload,
    type: actions.LOAD_TASKCODES_SUCCESS
});

export const createTaskCodeSuccess = (payload: models.TaskCodeDetailModel): TaskCodeAction => ({
    payload,
    type: actions.CREATE_TASKCODE_SUCCESS
});

export const saveTaskCodeSuccess = (payload: models.TaskCodeDetailModel): TaskCodeAction => ({
    payload,
    type: actions.SAVE_TASKCODE_SUCCESS
});

export const deleteTaskCodeSuccess = (id: any): TaskCodeAction => ({
    payload: id,
    type: actions.DELETE_TASKCODE_SUCCESS
});

export function createTaskCode(taskCode: models.TaskCodeCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_TASKCODE, TaskCodeApi.create(taskCode));
        dispatch(createTaskCodeSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveTaskCode(taskCode: models.TaskCodeEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_TASKCODE, TaskCodeApi.save(taskCode));

        dispatch(saveTaskCodeSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteTaskCode(id: any, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteTaskCode", TaskCodeApi.delete(id));
        dispatch(deleteTaskCodeSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export function loadTaskCodes() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadTaskCodes", TaskCodeApi.getAll());
        dispatch(loadTaskCodesSuccess(result));
    };
}

export const loadTaskCodeDetailSuccess = (taskCode: models.TaskCodeDetailModel) => ({
    payload: taskCode,
    type: actions.LOAD_TASKCODE_DETAIL_SUCCESS
});

export function loadTaskCodeDetail({ taskCodeId }: { taskCodeId: string }) {
    return async (dispatch: Dispatch, getState: () => models.AppState) => {
        const taskCode = getState().taskCodes.filter(c => c.id === taskCodeId)[0];

        if (taskCode === undefined
            || taskCode.detailUpdated === undefined
            || taskCode.detailUpdated.isBefore(taskCode.listUpdated)) {

            const action = taskCode === undefined ? createTaskCodeSuccess : loadTaskCodeDetailSuccess;

            const result = await loadAndTrack(dispatch, "loadTaskCodeDetail", TaskCodeApi.detail(taskCodeId));
            dispatch(action(result));
        }
    };
}
